import { currentOverviewImageSelector } from '@/redux/project/project.selectors';
import { useSelector } from 'react-redux';
import { OverviewImageLinkConfig } from '../OverviewImageModal.types';
import { getOverviewImageLinkPoints } from './getOverviewImageLinkPoints';
import { useOverviewImageLinkActions } from './useOverviewImageLinkActions';

export const useOverviewImageLinkConfigs = (): OverviewImageLinkConfig[] => {
  const { handleLinkClick } = useOverviewImageLinkActions();
  const currentImage = useSelector(currentOverviewImageSelector);

  if (!currentImage) return [];

  return currentImage.links.map(link => ({
    idObject: link.id,
    points: getOverviewImageLinkPoints(link),
    onClick: () => handleLinkClick(link),
  }));
};
